import { createBrowserRouter, Navigate, RouterProvider, Outlet } from "react-router-dom";
import { Dashboard } from "../pages/Dashboard";
import { NotFound } from "../pages/404";
import { Login } from "../pages/SignUp/Login";
import { ForgottenPassword } from "../pages/SignUp/ForgottenPassword";
import { ResetPassword } from "../pages/SignUp/ResetPassword";
import { useUserStatus } from "../hooks/core/UserStatus";
import { AddEmployee, EditEmployee, Employees, ArchiveNote as EmployeeArchiveNote } from "../pages/Employees";
import { AddNote as AddEmployeeNote, Notes as EmployeeNotes } from "../pages/Employees/pages/Notes";
import { Documents as EmployeeDocuments } from "../pages/Employees/pages/Documents";
import { Calendar } from "../pages/Calendar";
import { DayView as CalendarDayView } from "../pages/CalendarFetured/pages/DayView";
import { WeekView as CalendarWeekView } from "../pages/CalendarFetured/pages/WeekView";
import { AddEvent, EditEvent } from "../pages/Calendar/pages/Event";
import { Groups, AddGroup, EditGroup, AddGroupCalendar, AddGroupStudents, GroupProfessor, AddBulkCalendar, ArchiveNote } from "../pages/Groups";
import { Attendance, CancelClass, InformationAboutStudent } from "../pages/Groups/pages/Attendance";
import { Notifications } from "../pages/Notifications";
import { Students, AddStudent, EditStudent } from "../pages/Students";
import {Groups as StudentGroups, ViewArchiveNote} from "../pages/Students/pages/Groups"
import { AddNote, Notes } from "../pages/Students/pages/Notes";
import { Documents } from "../pages/Students/pages/Documents";
import { Documents as GroupDocumenta } from "../pages/Groups/pages/Documents";
import { Notes as GroupNotes } from "../pages/Groups/pages/Note";
import { AddNote as GroupNotesAdd } from "../pages/Groups/pages/Note";
import { AddTest, EditTest, Tests } from "../pages/Students/pages/Tests";
import { StudentCertificates } from "../pages/Students/pages/Certificates";
import { Profile } from "../pages/Profile";
import { Settings } from "../pages/Settings";
import { AddHoliday, EditHoliday, Holidays } from "../pages/Settings/pages/Calendar/pages/Holidays";
import { AddLocations, EditLocations, Locations } from "../pages/Settings/pages/Locations";
import Languages from "../pages/Settings/pages/Languages/pages/Languages/Languages";
import { AddLanguage, EditLanguage } from "../pages/Settings/pages/Languages/pages/Languages";
import Programs from "../pages/Settings/pages/Languages/pages/Programs/Programs";
import { AddProgram, EditProgram } from "../pages/Settings/pages/Languages/pages/Programs";
import { AddMonthly, EditMonthly, Monthly } from "../pages/Settings/pages/Reports/pages/Monthly";
import { Semiyearly } from "../pages/Settings/pages/Reports/pages/SemiAnnual";
import AddSemiyearly from "../pages/Settings/pages/Reports/pages/SemiAnnual/AddSemiyearly";
import EditSemiyearly from "../pages/Settings/pages/Reports/pages/SemiAnnual/EditSemiyearly";
import { AddYearly, EditYearly, Yearly } from "../pages/Settings/pages/Reports/pages/Annual";
import { AddRole, EditRole, Roles } from "../pages/Settings/pages/Employees/pages/Roles";
import { AddSchool, EditSchool, Schools } from "../pages/Settings/pages/Students/pages/Schools";
import NoteTypes from "../pages/Settings/pages/Default/pages/NoteTypes/NoteTypes";
import AddNoteType from "../pages/Settings/pages/Default/pages/NoteTypes/AddNoteType";
import AddPlan from "../pages/Settings/pages/Groups/pages/Plans/AddPlan";
import {AddPlan as GroupAddPlan} from "../pages/Groups/pages/Plannig";
import {EditPlan as GroupEditPlan} from "../pages/Groups/pages/Plannig";
import EditPlan from "../pages/Settings/pages/Groups/pages/Plans/EditPlan";
import Plans from "../pages/Settings/pages/Groups/pages/Plans/Plans";
import { Certificates } from "../pages/Settings/pages/Students/pages/Certificates";
import AddCertificate from "../pages/Settings/pages/Students/pages/Certificates/AddCertificates";
import EditCertificate from "../pages/Settings/pages/Students/pages/Certificates/EditCertificates";
import { AddMunicipality, EditMunicipality, Municipalities } from "../pages/Settings/pages/Default/pages/Municipalities";
import { Planning } from "../pages/Groups/pages/Plannig";
import { AddProgress, Progress, ProgressList } from "../pages/Groups/pages/Progress";
import GuardianTypes from "../pages/Settings/pages/Default/pages/GuardianTypes/GuardianTypes";
import AddGuardianType from "../pages/Settings/pages/Default/pages/GuardianTypes/AddGuardianType";
import { Support } from "../pages/Support";
import { AddType, EditType, Types } from "../pages/Settings/pages/Groups/pages/Types";
import { EditProgressType, EditProgressTypeOption, Progress as SettingsProgress } from "../pages/Settings/pages/Groups/pages/Progress";
import {AddProgress as AddSettingsProgress, EditProgress as EditSettingsProgress, AddProgressType as AddSettingsProgressType, AddProgressTypeOption as AddSettingsProgressTypeOption } from "../pages/Settings/pages/Groups/pages/Progress";
import ProgressNotes from "../pages/Groups/pages/Progress/pages/Notes/ProgressNotes";
import { EditProgressNote } from "../pages/Groups/pages/Progress/pages/Notes";
import { AddProgressTest, ProgressTests } from "../pages/Settings/pages/Groups/pages/ProgressTest";
import { ProgressTests as GroupProgressTests } from "../pages/Groups/pages/Tests";
import { Tests as GroupTests } from "../pages/Groups/pages/Tests";
import { AddTest as AddGroupProgressTests } from "../pages/Groups/pages/Tests";
import {EditTest as EditGroupTest} from "../pages/Groups/pages/Tests"
import { GeneralGrade, AddReport, EditReport, Reports, ReportsStudent } from "../pages/Groups/pages/Reports";
import { Types as ReportTypes } from "../pages/Settings/pages/Reports/pages/Types";
import {AddType as AddReportType} from "../pages/Settings/pages/Reports/pages/Types";
import {EditType as EditReportType} from "../pages/Settings/pages/Reports/pages/Types";
import { AddLegalEntity, EditLegalEntity, LegalEntities } from "../pages/Settings/pages/Locations/pages/LegalEntities";
import { AddContract, Contracts, EditContract, ViewContract } from "../pages/Students/pages/Contracts";
import SigneContract from "../pages/Students/pages/Contracts/SigneContract";
import TestsForProfessor from "../pages/Tests/TestsForProfessor";
import ScoreTest from "../pages/Tests/ScoreTest";
import PlanningNotes from "../pages/Groups/pages/Plannig/pages/Notes/PlanningNotes";
import EditPlanNote from "../pages/Groups/pages/Plannig/pages/Notes/EditPlanNote";
import { StudentDocuments } from "../pages/Documents";
import WeeklyReports from "../pages/WeeklyReports/WeeklyReports";
import { AddWeeklyReport, EditWeeklyReport, ViewWeeklyReport } from "../pages/WeeklyReports";
import WeeklyReportNotes from "../pages/WeeklyReports/pages/Notes/WeeklyReportNotes";
import { EditWeeklyReportNote } from "../pages/WeeklyReports/pages/Notes";
import Appointments from "../pages/Settings/pages/Calls/pages/Appointments/Appointments";
import AddAppointment from "../pages/Settings/pages/Calls/pages/Appointments/AddAppointment";
import EditAppointment from "../pages/Settings/pages/Calls/pages/Appointments/EditAppointment";
import { AddCourseType, CourseTypes, EditCourseType } from "../pages/Settings/pages/Calls/pages/CourseTypes";
import MethodesOfContact from "../pages/Settings/pages/Calls/pages/MethodOfContact/MethodesOfContact";
import AddMethodOfContact from "../pages/Settings/pages/Calls/pages/MethodOfContact/AddMethodOfContact";
import EditMethodOfContact from "../pages/Settings/pages/Calls/pages/MethodOfContact/EditMethodOfContact";
import { AddSalesChannel, SalesChannels } from "../pages/Settings/pages/Calls/pages/SalesChannels";
import EditSalesChannel from "../pages/Settings/pages/Calls/pages/SalesChannels/EditSalesChannel";
import StudentStatuses from "../pages/Settings/pages/Calls/pages/StudentStatuses/StudentStatuses";
import AddStudentStatus from "../pages/Settings/pages/Calls/pages/StudentStatuses/AddStudentStatus";
import EditStudentStatus from "../pages/Settings/pages/Calls/pages/StudentStatuses/EditStudentStatus";
import { AddStatus, EditStatus, Statuses } from "../pages/Settings/pages/Calls/pages/Statuses";
import { AddCall, Calls, EditCall, AddStudent as AddStudentFromCall } from "../pages/Calls";
import {Calls as StudentCall} from "../pages/Students/pages/Calls"
import { AddOfferSent, EditOfferSent, OfferSent } from "../pages/Settings/pages/Calls/pages/OfferSent";
import { ArchiveNote as StudentGroupArchiveNote} from "../pages/Students/pages/Groups"
import { AddAddress, Address, EditAddress } from "../pages/Settings/pages/Students/pages/Address";
import Guardians from "../pages/Guardians/Guardians";
import { EditGuardian, GuardianStudents } from "../pages/Guardians";

const PublicRoute = () => {
    const isLoggedIn = useUserStatus();
    return isLoggedIn ? <Navigate to="/calendar-featured/day-view" /> : <Outlet />;
};

const PrivateRoute = () => {
    const isLoggedIn = useUserStatus();
    return !isLoggedIn ? <Navigate to="/sign-up/login" /> : <Outlet />;
};

const router = createBrowserRouter([
    { path: "/", element: <Navigate to="/calendar-featured/day-view" /> },
    { path: "/dashboard", element: <PrivateRoute />, children: [{ path: "/dashboard", element: <Dashboard /> }] },
    { path: "/calendar", element: <PrivateRoute />, children: [{ path: "/calendar", element: <Calendar /> }] },
    {
        path: "/calendar-featured",
        element: <PrivateRoute />,
        children: [
            { path: "/calendar-featured/day-view", element: <CalendarDayView /> },
            { path: "/calendar-featured/week-view", element: <CalendarWeekView /> },
        ],
    },
    { path: "/sign-contract/:studentId/:contractId/:token", element: <SigneContract/> },
    {
        path: "/documents",
        element: <PrivateRoute />,
        children: [
            { path: "/documents", element: <StudentDocuments /> },
        ],
    },
    {
        path: "/tests",
        element: <PrivateRoute />,
        children: [
            { path: "/tests", element: <TestsForProfessor /> },
            { path: "/tests/:testId/students/:studentId", element: <ScoreTest /> },
        ],
    },
    {
        path: "/reports",
        element: <PrivateRoute />,
        children: [
            { path: "/reports", element: <WeeklyReports /> },
            { path: "/reports/add", element: <AddWeeklyReport /> },
            { path: "/reports/edit/:employeeWeeklyReport", element: <EditWeeklyReport /> },
            { path: "/reports/view/:employeeWeeklyReport", element: <ViewWeeklyReport /> },
            { path: "/reports/view/:employeeWeeklyReport/notes", element: <WeeklyReportNotes /> },
            { path: "/reports/view/:employeeWeeklyReport/notes/:weeklyReportNoteId", element: <EditWeeklyReportNote /> },
        ],
    },
    {
        path: "/calls",
        element: <PrivateRoute />,
        children: [
            { path: "/calls", element: <Calls /> },
            { path: "/calls/add", element: <AddCall /> },
            { path: "/calls/edit/:callId", element: <EditCall /> },
            { path: "/calls/:callId/add-student", element: <AddStudentFromCall /> },
        ],
    },
    {
        path: "/students",
        element: <PrivateRoute />,
        children: [
            { path: "/students", element: <Students /> },
            { path: "/students/add", element: <AddStudent /> },
            { path: "/students/edit/:studentId", element: <EditStudent /> },
            { path: "/students/:studentId/groups", element: <StudentGroups /> },
            { path: "/students/:studentId/groups/:selectedGroupId/archive-note", element: <StudentGroupArchiveNote /> },
            { path: "/students/:studentId/groups/:selectedGroupId/view-archive-note", element: <ViewArchiveNote /> },
            { path: "/students/:studentId", element: <Students /> },
            { path: "/students/:studentId/notes", element: <Notes /> },
            { path: "/students/:studentId/notes/add", element: <AddNote /> },
            { path: "/students/:studentId/documents", element: <Documents /> },
            { path: "/students/:studentId/tests", element: <Tests /> },
            { path: "/students/:studentId/tests/add", element: <AddTest /> },
            { path: "/students/:studentId/tests/:testId/edit", element: <EditTest /> },
            { path: "/students/:studentId/contracts", element: <Contracts /> },
            { path: "/students/:studentId/contracts/add", element: <AddContract/> },
            { path: "/students/:studentId/contracts/:contractId/view", element: <ViewContract/> },
            { path: "/students/:studentId/contracts/:contractId/edit", element: <EditContract/> },
            { path: "/students/signe_contract/:studentId/:contractId/:token", element: <SigneContract/> },
            { path: "/students/:studentId/certificates", element: <StudentCertificates /> },
            { path: "/students/:studentId/calls", element: <StudentCall /> },
        ],
    },
    {
        path: "/guardians",
        element: <PrivateRoute />,
        children: [
            { path: "/guardians", element: <Guardians /> },
            { path: "/guardians/edit/:guardianId", element: <EditGuardian /> },
            { path: "/guardians/:guardianId/students", element: <GuardianStudents /> },
        ],
    },
    {
        path: "/employees",
        element: <PrivateRoute />,
        children: [
            { path: "/employees", element: <Employees /> },
            { path: "/employees/add", element: <AddEmployee /> },
            { path: "/employees/edit/:employeeId", element: <EditEmployee /> },
            { path: "/employees/:employeeId/notes", element: <EmployeeNotes /> },
            { path: "/employees/:employeeId/notes/add", element: <AddEmployeeNote /> },
            { path: "/employees/:employeeId/documents", element: <EmployeeDocuments /> },
            { path: "/employees/:employeeId/archive-note", element: <EmployeeArchiveNote /> },
        ],
    },
    {
        path: "/calendar",
        element: <PrivateRoute />,
        children: [
            { path: "/calendar", element: <Calendar /> },
            { path: "/calendar/add-event", element: <AddEvent /> },
            { path: "/calendar/edit-event/:meetingId", element: <EditEvent /> }
        ],
    },
    {
        path: "/groups",
        element: <PrivateRoute />,
        children: [
            { path: "/groups", element: <Groups /> },
            { path: "/groups/add", element: <AddGroup /> },
            { path: "/groups/edit/:groupId", element: <EditGroup /> },
            { path: "/groups/:groupId/archive-note", element: <ArchiveNote /> },
            { path: "/groups/:groupId/calendar/add", element: <AddGroupCalendar /> },
            { path: "/groups/:groupId/calendar/bulk", element: <AddBulkCalendar /> },
            { path: "/groups/:groupId/students/add", element: <AddGroupStudents /> },
            { path: "/groups/add/students", element: <AddGroupStudents /> },
            { path: "/groups/:groupId/attendance", element: <Attendance /> },
            { path: "/groups/:groupId/cancel-class/:dateId", element: <CancelClass /> },
            { path: "/groups/:groupId/information-about-student/:studentId", element: <InformationAboutStudent /> },
            { path: "/groups/:groupId/planning", element: <Planning /> },
            { path: "/groups/:groupId/planning/:dateId/add/classIndex/:classIndex", element: <GroupAddPlan /> },
            { path: "/groups/:groupId/planning/:dateId/edit/:planId/classIndex/:classIndex", element: <GroupEditPlan /> },
            { path: "/groups/:groupId/planning/:planId/notes/:dateId/classIndex/:classIndex", element: <PlanningNotes /> },
            { path: "/groups/:groupId/planning/:planId/notes/:groupPlanNoteId/edit/:dateId/classIndex/:classIndex", element: <EditPlanNote /> },
            // { path: "/groups/:groupId/progress", element: <Progress /> },
            { path: "/groups/:groupId/progress", element: <ProgressList /> },
            { path: "/groups/:groupId/progress/student/:studentId/classNumber/:classNumber", element: <AddProgress /> },
            { path: "/groups/:groupId/progress/:groupProgressId/notes", element: <ProgressNotes /> },
            { path: "/groups/:groupId/progress/:groupProgressId/notes/:groupProgressNoteId/edit", element: <EditProgressNote /> },
            { path: "/groups/:groupId/tests", element: <GroupTests /> },
            { path: "/groups/:groupId/tests/add", element: <AddGroupProgressTests /> },
            { path: "/groups/:groupId/tests/edit/:groupProgressTestsId", element: <EditGroupTest /> },
            { path: "/groups/:groupId/progress/test/:groupProgressTestsId", element: <GroupProgressTests /> },
            { path: "/groups/:groupId/reports", element: <Reports /> },
            { path: "/groups/:groupId/reports/add", element: <AddReport /> },
            { path: "/groups/:groupId/reports/edit/:reportId", element: <EditReport /> },
            { path: "/groups/:groupId/student-reports/:reportId", element: <ReportsStudent /> },
            { path: "/groups/:groupId/student/:studentId/reports/:reportId/general-grade", element: <GeneralGrade /> },
            { path: "/groups/:groupId/documents", element: <GroupDocumenta /> },
            { path: "/groups/:groupId/notes", element: <GroupNotes /> },
            { path: "/groups/:groupId/notes/add", element: <GroupNotesAdd /> },
            { path: "/groups/:groupId/professor", element: <GroupProfessor /> },
        ],
    },
    {
        path: "/notifications",
        element: <PrivateRoute />,
        children: [{ path: "/notifications", element: <Notifications /> }],
    },
    {
        path: "/profile",
        element: <PrivateRoute />,
        children: [{ path: "/profile", element: <Profile /> }],
    },
    {
        path: "/sign-up",
        element: <PublicRoute />,
        children: [
            { path: "/sign-up/login", element: <Login /> },
            { path: "/sign-up/forgotten-password", element: <ForgottenPassword /> },
            { path: "/sign-up/reset-password/:token", element: <ResetPassword /> },
        ],
    },

    {
        path: "/settings",
        element: <PrivateRoute />,
        children: [
            { path: "/settings", element: <Settings /> },
            { path: "/settings/locations/locations", element: <Locations /> },
            { path: "/settings/locations/locations/add", element: <AddLocations /> },
            { path: "/settings/locations/locations/edit/:locationId", element: <EditLocations /> },
            { path: "/settings/locations/legal-entities", element: <LegalEntities /> },
            { path: "/settings/locations/legal-entities/add", element: <AddLegalEntity /> },
            { path: "/settings/locations/legal-entities/edit/:legalEntityId", element: <EditLegalEntity /> },
            { path: "/settings/languages/languages", element: <Languages /> },
            { path: "/settings/languages/languages/add", element: <AddLanguage /> },
            { path: "/settings/languages/languages/edit/:languageId", element: <EditLanguage /> },
            { path: "/settings/programs/programs", element: <Programs /> },
            { path: "/settings/programs/programs/add", element: <AddProgram /> },
            { path: "/settings/programs/programs/edit/:programId", element: <EditProgram /> },
            { path: "/settings/employees/roles", element: <Roles /> },
            { path: "/settings/employees/roles/add", element: <AddRole /> },
            { path: "/settings/employees/roles/edit/:roleId", element: <EditRole /> },
            { path: "/settings/default/note-types", element: <NoteTypes /> },
            { path: "/settings/default/note-types/add", element: <AddNoteType /> },
            { path: "/settings/default/guardian-types", element: <GuardianTypes /> },
            { path: "/settings/default/guardian-types/add", element: <AddGuardianType /> },
            { path: "/settings/students/schools", element: <Schools /> },
            { path: "/settings/students/schools/add", element: <AddSchool /> },
            { path: "/settings/students/schools/edit/:schoolId", element: <EditSchool /> },
            { path: "/settings/students/certificates", element: <Certificates /> },
            { path: "/settings/students/certificates/add", element: <AddCertificate /> },
            { path: "/settings/students/certificates/edit/:certificateId", element: <EditCertificate /> },
            { path: "/settings/students/address", element: <Address /> },
            { path: "/settings/students/address/add", element: <AddAddress /> },
            { path: "/settings/students/address/edit/:addressId", element: <EditAddress /> },
            { path: "/settings/reports/types", element: <ReportTypes /> },
            { path: "/settings/reports/types/add", element: <AddReportType /> },
            { path: "/settings/reports/types/edit/:reportTypeId", element: <EditReportType /> },
            { path: "/settings/reports/monthly", element: <Monthly /> },
            { path: "/settings/reports/monthly/add", element: <AddMonthly /> },
            { path: "/settings/reports/monthly/edit/:reportId", element: <EditMonthly /> },
            { path: "/settings/reports/semiyearly", element: <Semiyearly /> },
            { path: "/settings/reports/semiyearly/add", element: <AddSemiyearly /> },
            { path: "/settings/reports/semiyearly/edit/:reportId", element: <EditSemiyearly /> },
            { path: "/settings/reports/yearly", element: <Yearly /> },
            { path: "/settings/reports/yearly/add", element: <AddYearly /> },
            { path: "/settings/reports/yearly/edit/:reportId", element: <EditYearly /> },
            { path: "/settings/groups/plans", element: <Plans/>},
            { path: "/settings/groups/plans/add", element: <AddPlan />},
            { path: "/settings/groups/plans/edit/:planId", element: <EditPlan />},
            { path: "/settings/groups/types", element: <Types/>},
            { path: "/settings/groups/types/add", element: <AddType />},
            { path: "/settings/groups/types/edit/:groupTypeId", element: <EditType />},
            { path: "/settings/groups/progress", element: <SettingsProgress/>},
            { path: "/settings/groups/progress/add", element: <AddSettingsProgress />},
            { path: "/settings/groups/progress/:groupProgressId/edit", element: <EditSettingsProgress />},
            { path: "/settings/groups/progress/:groupProgressId/type/add", element: <AddSettingsProgressType />},
            { path: "/settings/groups/progress/:groupProgressId/type/:groupProgressTypeId/edit", element: <EditProgressType />},
            { path: "/settings/groups/progress/:groupProgressId/type/:groupProgressTypeId/options/add", element: <AddSettingsProgressTypeOption />},
            { path: "/settings/groups/progress/:groupProgressId/type/:groupProgressTypeId/options/:settingsGroupProgressTypeOptionId/edit", element: <EditProgressTypeOption />},
            { path: "/settings/groups/progress-tests", element: <ProgressTests />},
            { path: "/settings/groups/progress-tests/add", element: <AddProgressTest />},
            { path: "/settings/calendar/holidays", element: <Holidays /> },
            { path: "/settings/calendar/holidays/add", element: <AddHoliday /> },
            { path: "/settings/calendar/holidays/edit/:holidayId", element: <EditHoliday /> },
            { path: "/settings/default/municipalities", element: <Municipalities /> },
            { path: "/settings/default/municipalities/add", element: <AddMunicipality /> },
            { path: "/settings/default/municipalities/edit/:municipalityId", element: <EditMunicipality /> },
            { path: "/settings/calls/appointments", element: <Appointments /> },
            { path: "/settings/calls/appointments/add", element: <AddAppointment /> },
            { path: "/settings/calls/appointments/edit/:appointmentId", element: <EditAppointment /> },
            { path: "/settings/calls/course-type", element: <CourseTypes /> },
            { path: "/settings/calls/course-type/add", element: <AddCourseType /> },
            { path: "/settings/calls/course-type/edit/:courseTypeId", element: <EditCourseType /> },
            { path: "/settings/calls/method-of-contact", element: <MethodesOfContact /> },
            { path: "/settings/calls/method-of-contact/add", element: <AddMethodOfContact /> },
            { path: "/settings/calls/method-of-contact/edit/:methodOfContactId", element: <EditMethodOfContact /> },
            { path: "/settings/calls/sales-channel", element: <SalesChannels /> },
            { path: "/settings/calls/sales-channel/add", element: <AddSalesChannel /> },
            { path: "/settings/calls/sales-channel/edit/:salesChannelId", element: <EditSalesChannel /> },
            { path: "/settings/calls/student-status", element: <StudentStatuses /> },
            { path: "/settings/calls/student-status/add", element: <AddStudentStatus /> },
            { path: "/settings/calls/student-status/edit/:studentStatusId", element: <EditStudentStatus /> },
            { path: "/settings/calls/status", element: <Statuses /> },
            { path: "/settings/calls/status/add", element: <AddStatus /> },
            { path: "/settings/calls/status/edit/:statusId", element: <EditStatus /> },
            { path: "/settings/calls/offer-sent", element: <OfferSent /> },
            { path: "/settings/calls/offer-sent/add", element: <AddOfferSent /> },
            { path: "/settings/calls/offer-sent/edit/:offerSentId", element: <EditOfferSent /> },
        ],
    },

    { path: "/404", element: <NotFound /> },
    { path: "*", element: <Navigate to="/404" /> },
    { path: "/support", element: <Support /> },
]);

const DefaultRouter = () => {
    return <RouterProvider router={router} />;
};

export default DefaultRouter;
